export interface UserAccountDetail {
  id: number;
  customerId: number;
  salutation: string;
  salutationType: string;
  academicTitle: string;
  firstName: string;
  lastName: string;
  email: string;
  emailConfirmed: boolean;
  mobile: string;
  mobileConfirmed: boolean;
  username: string;
  birthday: string | null;
  language: number;
  emailSenderAddress: string | null;
  phonePassword: string | null;
  status: string;
  missedCallNotificationEnabledByCustomer: boolean;
  missedCallNotificationEnabledByMarketing: boolean;
  enabled2FactorAuthentication: boolean;
}

/** `GET /useraccount/v1/uids` — the code is `uid` (EB-4453). */
export interface VerificationUid {
  id?: number;
  uid: string;
  uidCustomerType?: string;
  userAccountId?: number;
  expirationDate?: string;
}

/**
 * `POST /useraccount/v1/siporderlinks` — 201 body. Never contains the token or the link.
 * `expiresAt` carries an offset, e.g. `2026-10-21T23:30:00+02:00`.
 *
 * @ticket PS-6586
 */
export interface SipOrderLinkCreated {
  linkId: string;
  recipientMasked: string;
  expiresAt: string;
}

/**
 * Backend-owned error code of the 409 answer: useraccount's error body is
 * `{path, timestamp, error, message, status}` and the code sits in `error`.
 *
 * @ticket PS-6586
 */
export const SIP_ORDER_LINK_ERROR_NO_CONFIRMED_EMAIL = 'NO_CONFIRMED_EMAIL';
/** 500: brand data missing or the mail message could not be published; a retry may work. */
export const SIP_ORDER_LINK_ERROR_UNAVAILABLE = 'SIP_ORDER_LINK_UNAVAILABLE';
